import {
    CHANGE_RETAILER_PROFILE_DATA,
    RETAILER_BRAND_NAMES_SUGGESTIONS,
    RETAILER_PROFILE_SET_INITIAL,
} from "constants/action-types";
import { brandNamesQuery, saveProfileQuery } from "queries/retailer-profile-form";
import { requestAsync } from "lib/api";
import { push, replace } from "react-router-redux";
import me from "models/me";
import querystring from "querystring";

export const openRetailerProfile = (router, brandInfo?) => {
    return (dispatch) => {
        dispatch({
            type: RETAILER_PROFILE_SET_INITIAL,
            payload: {
                location: router.location,
                brandInfo,
                buyerFormSubmitted: me.buyer_form_submitted,
            },
        });
        dispatch(push("/retailer-profile"));
    };
};

export const changeRetailerProfileData = (profileData) => ({
    payload: { profileData },
    type: CHANGE_RETAILER_PROFILE_DATA,
});

export const updateRetailerProfile = (location) => {
    return (dispatch, getState) => {
        const { retailerProfileForm, entities } = getState();
        const { profileData, brandInfo } = retailerProfileForm;
        const legacyPayload = profileData.toLegacyFormat(entities.brandCategories);
        return dispatch(requestAsync(saveProfileQuery(legacyPayload))).then(({ status }) => {
            if (status < 400) {
                me.save(
                    { buyer_form_submitted: true },
                    {
                        patch: true,
                        success: () => {
                            const { pathname = "", query = {} } = location || {};
                            if (query.redirect) {
                                dispatch(replace(query.redirect));
                                return;
                            }
                            const search = querystring.stringify({
                                connectTo: brandInfo && brandInfo._id,
                                ...query,
                            });
                            dispatch(replace(`${pathname}?${search}`));
                        },
                    }
                );
            }
        });
    };
};

export const requestBrandSuggestions = () => {
    return (dispatch) => {
        return dispatch(requestAsync(brandNamesQuery())).then(({ body, status }) => {
            if (status === 200 && body.brands) {
                return dispatch({
                    payload: body.brands,
                    type: RETAILER_BRAND_NAMES_SUGGESTIONS,
                });
            }
        });
    };
};

export const exitProfileForm = () => {
    return (dispatch, getState) => {
        const { retailerProfileForm, ldFlags } = getState();
        const { location: { pathname = "", search = "" } = {} } = retailerProfileForm;
        const marketplaceURL = ldFlags ? "/site/nuordermarketplace" : "/browse/brands";

        dispatch(replace(pathname + search || marketplaceURL));
    };
};
